import React, { Component } from 'react';
import { Button, Checkbox, Col, Form, Input, notification, Row, Select, Spin } from 'antd';
import queryString from 'query-string';
import moment from 'moment';
import _ from 'lodash';

import * as enquiryController from '../../services/api/enquiry';
import { salutationOptions, leadTypeOptions } from '../../utils/options';
import GoogleRecaptchaInput from '../../components/GoogleRecaptchaInput/GoogleRecaptchaInput';
import logo from './logo.png';
import './EnquiryPage.scss'

const FormItem = Form.Item;
const Option = Select.Option;
const TextArea = Input.TextArea;

export class EnquiryPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            programmes: [],
            channels: [],
            isSubmittingForm: false,
            formSubmitted: false,
            isCodeValid: false,
        };
    }

		getFormLabel(options = [], value) {
			const option = _.find(options, { id: value });

			return _.isEmpty(option) ? value : option.name
		}

    fetchProgrammes() {
        enquiryController.getProgrammes()
            .then((res) => res.json())
            .then((json) => this.setState({ programmes: json }))
    }

    fetchChannels() {
        enquiryController.getChannels()
            .then((res) => res.json())
            .then((json) => this.setState({ channels: json }))
    }

    validateAgreementCheckbox(rule, value, callback) {
    	if (!value) {
    		callback('Please agree the statement.');
    	} else {
    		callback();
    	}
    }

    componentDidMount() {
        const { location, form } = this.props;
        const parsed = queryString.parse(location.search);
        let promises = [this.fetchProgrammes(), this.fetchChannels()];

        this.setState({ isLoading: true });

        if (parsed.code) {
            promises.push(enquiryController.getEnquiry(parsed.code)
                .then((res) => res.json())
                .then((json) => {
                    const { enquiry_type, programme, channel } = json;

                    form.setFieldsValue({
                        type: enquiry_type,
                        interested_programme_id: programme && programme.id,
                        channel_id: channel && channel.id
                    });

                    this.setState({ isCodeValid: true })
                })
                .catch((err) => console.log(err)))
        }

        Promise.all(promises)
            .then(() => this.setState({ isLoading: false }))
    }

    handleSubmit(e) {
        const { location, form } = this.props;
        const { isCodeValid } = this.state;
        const parsed = queryString.parse(location.search);
        e.preventDefault();

        form.validateFields((err, values) => {
            console.log(values);
            if (!err) {
                const { salutation, name, email, contact_number, company_name, occupation, ...rest } = values;
                let body = {
                    customer: {
                        name: `${salutation} ${name}`,
                        email,
                        contact_number,
                        company_name,
                        occupation
                    },
                    enquiry_date: moment().toISOString(),
                    ...rest
                };

                this.setState({ isSubmittingForm: true });

                if (parsed.code && isCodeValid)
                    body.code = parsed.code;

                enquiryController.createEnquiry(body)
                    .then((res) => res.json())
                    .then((json) => this.setState({ isSubmittingForm: false, formSubmitted: true }))
                    .catch((err) => {
                        notification.error({
                            message: 'Unexpected Error',
                            description: 'Please report this issue to engineer.',
                            duration: 0
                        });
                        this.setState({ isSubmittingForm: false });
                    })
            }
        });
    }

    render() {
        const { form } = this.props;
        const { programmes, channels, isSubmittingForm, formSubmitted, isCodeValid, isLoading } = this.state;
        const { getFieldDecorator, getFieldValue } = form;

        const uniqedProgrammes = _.uniqBy(programmes, 'course_code.id');

        const programmeOptions = _.map(uniqedProgrammes, (programme) =>
            <Option key={programme.id} value={programme.id}>
                {`[${programme.course_code ? programme.course_code.name : 'N/A'}] ${programme.name}`}
            </Option>);
        const channelOptions = _.map(channels, (channel) => 
            <Option key={channel.id} value={channel.id}>
                {`[${channel.type ? channel.type.name : 'N/A'}]${channel.name} - ${channel.source ? channel.source.name : 'N/A'}`}
            </Option>);
        const enquiryTypeOptions = _.map(leadTypeOptions, (enquiryType) => <Option key={enquiryType} value={enquiryType}>{enquiryType}</Option>);
        const salutationOptionComponents = _.map(salutationOptions, (salutation) => <Option key={salutation} value={salutation}>{salutation}</Option>);

        const isAboutProgramme = form.getFieldValue('type') !== 'Other Enquiry';

        if (formSubmitted)
            return (
                <div className="EnquiryPage">
					<div className="EnquiryPage-container">
	                    <div className="EnquiryPage-logo-container">
	                        <img className="EnquiryPage-logo" src={logo} alt="Informatics Logo"/>
	                    </div>
	                    <p className="EnquiryPage-message">Enquiry Submitted. <br/>Our education/ training consultant will contact you within 2 working days.</p>
	                   	<div className="EnquiryPage-contact-information" style={{ textAlign: 'center' }}>
	                    	<div><b>Informatics Education (HK)</b></div>
							<div><a href="https://goo.gl/maps/qtPqkLftUGT2">Room 5/F, Hecny Tower, 9 Chatham Road South, Tsimshatsui, Kowloon, Hong Kong</a></div>
							<div><b>Tel:</b> <a href="tel:+85235566000">3556 6000</a> <b>Fax:</b> <a href="tel:+85227242663">2724 2663</a> <b>Website:</b> <a href="http://www.informatics.edu.hk">http://www.informatics.edu.hk</a></div>
	                    </div>
					</div>
				</div>
            )
        else
            return (
                <Spin spinning={isLoading}>
	                <div className="EnquiryPage">
		                <div className="EnquiryPage-container">
		                    <div className="EnquiryPage-logo-container">
		                        <img className="EnquiryPage-logo" src={logo} alt="Informatics Logo"/>
		                    </div>
		                    <p className="EnquiryPage-greeting">Thank you for your enquiry! Please fill in the following information, our education/ training consultant will help you within 2 working days.</p>
		                    <Form className="EnquiryPage-form" onSubmit={(e) => this.handleSubmit(e)}>
		                    	<Row gutter={8}>
		                    		<Col span={24}>
				                        <FormItem>
				                            {
																			getFieldDecorator('type', {
																					rules: [{ required: true, message: 'Please select the enquiry type.' }],
																			})(
																				isCodeValid ? 
																				<div className="prefilled-input">
																					<b>Enquiry Type:</b> {getFieldValue("type")}
																				</div> :
																				<Select placeholder="Enquiry Type">
																					{enquiryTypeOptions}
																				</Select>
																			)
																		}
				                        </FormItem>
		                    		</Col>
		                    	</Row>
		                    	{
		                    		isAboutProgramme &&
			                    	<Row gutter={8}>
			                    		<Col span={24}>
					                        <FormItem>
					                            {getFieldDecorator('interested_programme_id', {
					                                rules: [{ required: isAboutProgramme, message: 'Please select the programme you are enquiring.' }],
					                            })(
																				isCodeValid ? 
																				<div className="prefilled-input">
																					<b>Program:</b> {this.getFormLabel(uniqedProgrammes, getFieldValue("interested_programme_id"))}
																				</div> :
					                            	<Select placeholder="Programme">
				                            			{programmeOptions}
					                            	</Select>
					                            )}
					                        </FormItem>
			                    		</Col>
			                    	</Row>
		                    	}
		                    	<Row gutter={8}>
		                    		<Col span={12}>
				                        <FormItem>
				                            {getFieldDecorator('salutation', {
				                                rules: [{ required: true, message: 'Please input your salutation.' }],
				                            })(
				                            	<Select placeholder="Salutation">
				                            		{salutationOptionComponents}
				                            	</Select>
				                            )}
				                        </FormItem>
		                    		</Col>
		                    		<Col span={12}>
				                        <FormItem>
				                            {getFieldDecorator('name', {
				                                rules: [{ required: true, message: 'Please input your name.' }],
				                            })(
				                                <Input placeholder="Name"/>
				                            )}
				                        </FormItem>
		                    		</Col>
		                    	</Row>
		                    	<Row gutter={8}>
		                    		<Col span={12}>
				                        <FormItem>
				                            {getFieldDecorator('email', {
				                                rules: [{ required: true, message: 'Please input your email.' }],
				                            })(
				                                <Input placeholder="Email"/>
				                            )}
				                        </FormItem>
		                    		</Col>
		                    		<Col span={12}>
				                        <FormItem>
				                            {getFieldDecorator('contact_number', {
				                                rules: [{ required: true, message: 'Please input your contact number.' }],
				                            })(
				                                <Input placeholder="Contact Number"/>
				                            )}
				                        </FormItem>
		                    		</Col>
		                    	</Row>
		                    	<Row gutter={8}>
		                    		<Col span={12}>
				                        <FormItem>
				                            {getFieldDecorator('company_name')(
				                                <Input placeholder="Company Name"/>
				                            )}
				                        </FormItem>
		                    		</Col>
		                    		<Col span={12}>
				                        <FormItem>
				                            {getFieldDecorator('occupation')(
				                                <Input placeholder="Occupation"/>
				                            )}
				                        </FormItem>
		                    		</Col>
		                    	</Row>
		                    	<Row gutter={8}>
		                    		<Col span={24}>
				                        <FormItem>
				                            {getFieldDecorator('channel_id', {
				                                rules: [{ required: true, message: 'Please select the channel of knowing informatics.' }],
				                            })(
																			isCodeValid ? 
																			<div className="prefilled-input">
																				<b>Channel of knowing informatics:</b> {this.getFormLabel(channels, getFieldValue("channel_id"))}
																			</div> :
				                            	<Select placeholder="Channel of knowing informatics">
				                            		{channelOptions}
				                            	</Select>
				                            )}
				                        </FormItem>
		                    		</Col>
		                    	</Row>
		                    	<Row gutter={8}>
		                    		<Col span={24}>
				                        <FormItem>
				                            {getFieldDecorator('message')(
				                            	<TextArea autosize={{ minRows: 4, maxRows: 4 }} placeholder="Your message"/>
				                            )}
				                        </FormItem>
		                    		</Col>
		                    	</Row>
		                    	<Row gutter={8}>
		                    		<Col span={24}>
				                        <FormItem>
				                            {getFieldDecorator('agreement', {
				                            	valuePropName: 'checked',
				                            	rules: [
				                            		{ validator: (rule, value, callback) => this.validateAgreementCheckbox(rule, value, callback) }
				                            	]
				                            })(
				                            	<Checkbox>是的，我同意按照<a href="http://www.informatics.edu.hk/about-us/privacy-policy/">隱私政策</a>的規定，接受Informatics Education (HK) Ltd 通過郵件或電話跟我聯繫。</Checkbox>
				                            )}
				                        </FormItem>
		                    		</Col>
		                    	</Row>
		                    	<Row gutter={8}>
		                    		<Col span={24}>
		                    			<FormItem>
		                    				{
		                    					getFieldDecorator('recaptcha', {
				                                	rules: [{ required: true, message: 'Please verify you are a human.' }],
		                    					})(
		                    						<GoogleRecaptchaInput/>
		                    					)
		                    				}
		                    			</FormItem>
		                    		</Col>
		                    	</Row>
		                    	<Row gutter={8}>
		                    		<Col span={24}>
				                        <FormItem>
				                            <Button type="primary" htmlType="submit" className="submit-button" loading={isSubmittingForm}>Submit</Button>
				                        </FormItem>
		                    		</Col>
		                    	</Row>
		                    </Form>
		                    <p className="EnquiryPage-contact-terms">Upon request of un-subscription, Informatics Education (HK) guarantees the permanent removal of your email address from our email list. We collect your information for communication purpose only and will not share your information with or sell it to any other parties. PMP is a registered mark of the Project Management Institute, Inc.</p>
		                    <div className="EnquiryPage-contact-information">
		                    	<div><b>Informatics Education (HK)</b></div>
								<div><a href="https://goo.gl/maps/qtPqkLftUGT2">Room 5/F, Hecny Tower, 9 Chatham Road South, Tsimshatsui, Kowloon, Hong Kong</a></div>
								<div><b>Tel:</b> <a href="tel:+85235566000">3556 6000</a> <b>Fax:</b> <a href="tel:+85227242663">2724 2663</a> <b>Website:</b> <a href="http://www.informatics.edu.hk">http://www.informatics.edu.hk</a></div>
		                    </div>
		                </div>
		            </div>
	            </Spin>
            );
    }
}

const WrappedEnquiryPage = Form.create()(EnquiryPage);
export default WrappedEnquiryPage;


// WEBPACK FOOTER //
// ./src/scenes/EnquiryPage/EnquiryPage.js